import * as core from './core'
import * as heroiconsMicro from './heroicons-micro'
import * as heroiconsMini from './heroicons-mini'
import * as heroiconsOutline from './heroicons-outline'
import * as heroiconsSolid from './heroicons-solid'
import * as micro from './micro'
import * as nova from './nova'
import * as ultimate from './ultimate'

export const Glyphs = { nova, ultimate, core, micro, heroiconsMini, heroiconsMicro, heroiconsSolid, heroiconsOutline }
